import { Link } from "@mui/material";

import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";

import SeatMap3dPreview from "public/images/winnipegjets_flex/SSbackgroundimage.jpg";
import AuthBackgroundBanner from "public/images/winnipegjets_flex/SSbackgroundimage.jpg";
import FindGamesBanner from "public/images/winnipegjets_flex/2425JETS013-0501_Game-Packs_WEB_1486x148_v1.jpg";

import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import {
  faqs,
  howItWorks,
  purchaseSeatsLanguages,
  purchaseGiftCardLanguages,
} from "./helpers";

import type { TeamConfig } from "../types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NHL_2024_v3/jets-assets/Primary%20Logo/NHL_Jets_Primary.png";

const config: TeamConfig = {
  teamSchema: "winnipegjets_flex_sandbox",
  browserTitle: "Winnipeg Jets Game Packs",
  packages: false,
  teamName: "Winnipeg Jets",

  packs: {
    enabled: true,
    autoContinueOnLastPack: false,
    list: [
      {
        id: 1,
        amount: 4,
        title: "4 Game Pack",
        description:
          "Choose a total of 4 games across four tiers for 10% off your ticket price!",
        offerMoreMessage:
          "Would you like to add 2 more games and get 15% off your tickets?",
        buckets: [
          {
            id: 1,
            title: "Tier 1",
            description: "Pick 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 2,
            title: "Tier 2",
            description: "Pick 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 3,
            title: "Tier 3",
            description: "Pick 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 4,
            title: "Tier 4",
            description: "Pick 1 Game",
            max: 1,
            min: 1,
          },
        ],
        updatedAccountGroup: 0,
        successMessage:
          "Would you like to add 2 more games and unlock 15% off your tickets?",
      },
      {
        id: 2,
        amount: 6,
        title: "6 Game Pack",
        description:
          "Choose a total of 6 games across four tiers for 15% off your ticket price!",
        offerMoreMessage:
          "Would you like to add 2 more games and get 20% off your tickets?",
        defaultSelected: true,
        buckets: [
          {
            id: 1,
            title: "Tier 1",
            description: "Pick 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 2,
            title: "Tier 2",
            description: "Pick 2 Games",
            max: 2,
            min: 2,
          },
          {
            id: 3,
            title: "Tier 3",
            description: "Pick 2 Games",
            max: 2,
            min: 2,
          },
          {
            id: 4,
            title: "Tier 4",
            description: "Pick 1 Game",
            max: 1,
            min: 1,
          },
        ],
        updatedAccountGroup: 1,
        successMessage:
          "Would you like to add 2 more games and unlock 20% off your tickets?",
      },
      {
        id: 3,
        amount: 8,
        title: "8 Game Pack",
        description:
          "Choose a total of 8 games across four tiers for 20% off your ticket price!",
        offerMoreMessage: "",
        buckets: [
          {
            id: 1,
            title: "Tier 1",
            description: "Pick 2 Games",
            max: 2,
            min: 2,
          },
          {
            id: 2,
            title: "Tier 2",
            description: "Pick 2 Games",
            max: 2,
            min: 2,
          },
          {
            id: 3,
            title: "Tier 3",
            description: "Pick 2 Games",
            max: 2,
            min: 2,
          },
          {
            id: 4,
            title: "Tier 4",
            description: "Pick 2 Games",
            max: 2,
            min: 2,
          },
        ],
        updatedAccountGroup: 2,
        successMessage: "Add more games or checkout now!",
      },
    ],
  },

  manageCard: true,

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.giftCard,
    hideRedeemItem: true,
    hideRecipient: true,
  },

  // disabled routes
  disabledRoutes: [],

  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-ca-10006-jets-sec",
    mapId: "main",
  },

  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    showFrontendTotalAmount: true,
    showFrontendServiceFee: true,
    allowManualCartInSimilar: false,
    isPerksEnabled: false,

    defaultSeatCount: 2,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: true,
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  isBrainTreePaymentEnabled: false,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "G-QGN1EHSF4S",
    attrkPixelId: "",
    beaconId: "",
    metaPixelId: "1900006853612117",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/tnse/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBackgroundBanner.src,
    checkoutStatusPageImage: AuthBackgroundBanner.src,
    giftCardStandalonePageImage: AuthBackgroundBanner.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  colors: {
    primary: "#041E42",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    hideCheckoutCartBalance: true,

    checkoutStatusPage: {
      checkoutSuccessMessageFontSize: "16px",
      checkoutSuccessMessageFontWeight: "normal",
    },
  },

  languages: {
    topNavMenuItems: <></>,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: null,
    purchaseSeats: purchaseSeatsLanguages,

    checkoutSuccessMessage:
      "Tickets are now available to view in your TN Ticket Central Account Manager!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Canada Life Centre.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Canada Life Centre.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to yout account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
